<script lang="ts">
    import CriteriaPage from '@Criteria/Hierarchies/Pages/CriteriaPage'
    export default CriteriaPage
</script>

<template>
    <div>
        <CriterionCreator :viewModel="criterionCreator"
                          @create-criterion="handleCreateCriterionCommand" />

        <CriterionEditor :viewModel="criterionEditor"
                         @delete-criterion="showCriterionDeleter"
                         @update-criterion="handleUpdateCriterionCommand" />

        <CriterionDeleter :viewModel="criterionDeleter"
                          @delete-criterion="handleDeleteCriterionCommand" />

        <AttributeLibrary :viewModel="attributeLibrary"
                          @create-criterion="handleCreateCriterionFromAttributeCommand" />

        <CriteriaFromStringBuilder :viewModel="criteriaFromStringBuilder"
                                   @create-criteria="handleCreateCriteriaFromStringCommand" />

        <CriteriaLibrary :viewModel="criteriaLibrary"
                         @create-criterion="handleCreateCriterionFromTemplateCommand"
                         @show-scale="showScaleTemplateViewer" />

        <ScaleTemplateViewer :viewModel="scaleTemplateViewer" />

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <h3 v-if="!Initialized"><i class="fa fa-spinner fa-spin"></i> Loading... </h3>
            <div v-if="Initialized" @dragover.prevent="onDragOver">
                <a class="btn btn-outline-secondary float-right" href="https://www.transparentchoice.com/user-guide/build-criteria" title="User guide: Build criteria" target="_blank">
                    <i class="fa fa-info" aria-hidden="true"></i>
                </a>
                <h3>
                    Goal: {{goalName}}
                </h3>
                <br />
                <GoalNavigation ActivePage="criteria-hierarchy" :WorkspaceId="workspaceId" :ProjectId="projectId" :EvalModelId="evalModelId"  :ScoringEnabled="ScoringEnabled"></GoalNavigation>
                <div class="alert alert-info alert-dismissible">
                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                    <p>Use this screen to create your criterion hierarchy. To create a new criterion, simply click on the gear-wheel.</p>
                </div>

                <div>
                    <div v-for="vm in criteriaView" :key="vm.CriterionId" :style="{ 'marginLeft': vm.Level*50 + 'px', cursor: isDragEnabled(vm.CriterionId) ? 'move' : 'default' }">

                        <div class="Criterion" draggable="true"
                             @dragstart="onDragStart($event, vm)"
                             @dragend="onDragEnd($event, vm)"
                             @dragenter="onDragEnter($event, vm)"
                             @dragleave="onDragLeave($event, vm)"
                             @drop="onDrop($event, vm)">

                            <div class="tile" :class="{ 'CriterionHovered': vm.DragOver }">

                                <div class="dropdown" style="position: absolute; right: 40px;">
                                    <a class="text-dark" data-toggle="dropdown">
                                        <i class="fa fa-cog fa-lg"></i>
                                    </a>
                                    <div role="menu" class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item" @click="showCriterionEditor(vm)">Edit</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" @click="showCriterionCreator(vm)">Add sub-criterion</a>
                                        <a class="dropdown-item" @click="showCriteriaFromStringBuilder(vm)">Add many</a>
                                        <a class="dropdown-item" @click="showAttributeLibrary(vm)">Add from attributes</a>
                                        <a class="dropdown-item" @click="showCriteriaLibrary(vm)">Add from criterion library</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" @click="showCriterionDeleter(vm.CriterionId)" v-if="!isGoal(vm.CriterionId)">Delete</a>
                                    </div>
                                </div>

                                <div class="pointer" @click="showCriterionEditor(vm)">
                                    <h5 class="text-ellipsis fg-color-gray">
                                        <i v-if="hasSubCriteria(vm.CriterionId)"
                                           :class="vm.IsCollapsed ? 'fa fa-folder' : 'fa fa-folder-open'"
                                           @click.stop="vm.IsCollapsed = !vm.IsCollapsed">
                                        </i>

                                        <span>{{ vm.Name }}</span>
                                    </h5>
                                    <small class="text-ellipsis fg-color-gray1">{{ vm.Description || '&nbsp;' }}</small>
                                    <div v-if="isDragEnabled(vm.CriterionId)" class="CriterionDragHandler" title="Click and hold to drag criterion"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .tile {
        position: relative;
        height: 75px;
        margin-bottom: 10px;
    }

    .Criterion {
    }

    .CriterionHovered {
        background-color: rgb(255, 164, 9) !important;
    }

    .CriterionDragHandler {
        position: absolute; /* Adjust if needed */
        right: -1px; /* Adjust if needed */
        top: -1px; /* Adjust based on your needs */
        height: 75px;
        width: 30px;
        cursor: move;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        -webkit-border-top-right-radius: 4px;
        -webkit-border-bottom-right-radius: 4px;
        -moz-border-top-right-radius: 4px;
        -moz-border-bottom-right-radius: 4px;
        background-color: gray;
        background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.2) 10%, transparent 10%, transparent 20%, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.2) 30%, transparent 30%, transparent 40%, rgba(255, 255, 255, 0.2) 40%, rgba(255, 255, 255, 0.2) 50%, transparent 50%, transparent 60%, rgba(255, 255, 255, 0.2) 60%, rgba(255, 255, 255, 0.2) 70%, transparent 70%, transparent 80%, rgba(255, 255, 255, 0.2) 80%, rgba(255, 255, 255, 0.2) 90%, transparent 90%);
    }
</style>
